import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackRegeneratedContentCollectionLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackRegeneratedContentCollectionLink = useCallback(() => {
    track(`Regenerated a content collection link`);
  }, [track]);

  return { trackRegeneratedContentCollectionLink };
};
